import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white/70 backdrop-blur-sm" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src="/86bit-logo.jpg" alt="86BIT" className="w-12 h-12 rounded-lg object-contain bg-white ring-1 ring-slate-200" data-testid="footer-logo" />
            <div>
              <p className="font-bold text-slate-900 leading-tight">Customer Scout</p>
              <p className="text-xs text-slate-500">by 86BIT srl Unipersonale</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs text-slate-600 flex-1 max-w-3xl md:pl-8">
            <div className="flex items-start gap-2">
              <MapPin className="w-3.5 h-3.5 mt-0.5 text-slate-400 flex-shrink-0" />
              <span>Piazza Papa Giovanni XXIII<br />24020 Scanzorosciate (BG)</span>
            </div>
            <div className="flex items-start gap-2">
              <Phone className="w-3.5 h-3.5 mt-0.5 text-slate-400 flex-shrink-0" />
              <a href="tel:+39035310900" className="hover:text-slate-900">+39 035 310 900</a>
            </div>
            <div className="flex items-start gap-2">
              <Mail className="w-3.5 h-3.5 mt-0.5 text-slate-400 flex-shrink-0" />
              <a href="mailto:info@86bit.it" className="hover:text-slate-900">info@86bit.it</a>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-slate-100 text-[11px] text-slate-500 leading-relaxed text-center md:text-left">
          © Copyright 2026 | <b>86BIT srl Unipersonale</b> — Codice Fiscale e P.Iva 04353030168 — Capitale sociale € 30.000,00 i.v. — Reg. Imprese di Bergamo 04353030168 — REA n. BG456578
        </div>
      </div>
    </footer>
  );
};

export default Footer;
